import { jwtEnvAxios } from ".";

export function getAiJobsApi() {
  return jwtEnvAxios("ai-lab").get(`/job/detail`);
}

export function updateAiJobApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/job/${id}`, data);
}

export function createAiJobApi(data: any) {
  return jwtEnvAxios("ai-lab").post(`/job`, data);
}

export function getAiJobPresetImageApi() {
  return jwtEnvAxios("ai-lab").get(`/job/capabilities/presetImage`);
}

export function deleteAiJobApi(id: string) {
  return jwtEnvAxios("ai-lab").delete(`/job/${id}?force`);
}

export function stopAiJobApi(id: string) {
  return jwtEnvAxios("ai-lab").put(`/job/${id}/kill`);
}

//
export function getAiJobApi(id: string) {
  return jwtEnvAxios("ai-lab").get(`/job/${id}`);
}

export function getAiJobLogsApi(id: string) {
  return jwtEnvAxios("ai-lab").get(`/job/${id}/log`);
}
